module.exports = __webpack_public_path__ + "static/Aruba.it-dc90699c02cb9aa6ee2607adcaf2484a.svg";